import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Security = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="security icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M13.25 9.25005V11.25H10.75V9.25005C10.75 8.55969 11.3096 8.00005 12 8.00005C12.6904 8.00005 13.25 8.55969 13.25 9.25005Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 6.16987V8.00005C2 21 11 24 12 24C13 24 22 21 22 8.00005V5.99991C22 5.44762 21.553 4.99601 21.0024 4.95198C19.9506 4.86784 18.2728 4.63645 17 4.00005C15.6646 3.33236 13.8834 1.55015 12.8471 0.439385C12.4063 -0.0330105 11.6279 -0.00487685 11.2056 0.484077C10.3085 1.52274 8.74462 3.12774 7 4.00005C5.47715 4.76147 4.09201 4.98372 3.16784 5.03187C2.55423 5.06385 2 5.55544 2 6.16987ZM9.25 9.25005C9.25 7.73126 10.4812 6.50005 12 6.50005C13.5188 6.50005 14.75 7.73126 14.75 9.25005V11.25H15C15.5523 11.25 16 11.6978 16 12.25V16.75C16 17.3023 15.5523 17.75 15 17.75H9C8.44772 17.75 8 17.3023 8 16.75V12.25C8 11.6978 8.44772 11.25 9 11.25H9.25V9.25005Z"
    />
  </svg>
)
